<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.push('/clientes')">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-card-header class="border-0">
          <h3 class="mb-0">{{ $t('informacion') }}</h3>
        </b-card-header>
        <b-form @submit.prevent="submitempresa">
          <b-row>
            <b-col md="6">
              <b-form-group label-for="nombreEmpresa">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombreEmpresa" v-model="form.nombre" required
                  :placeholder="$t('nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="rutEmpresa">
                <template v-slot:label>
                  {{ $t('rut') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="rutEmpresa" v-model="form.rut" required :placeholder="$t('rut')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="nombreFantasia">
                <template v-slot:label>{{ $t('nombre_fantasia') }}</template>
                <b-form-input id="nombreFantasia" v-model="form.nombreFantasia" maxlength="200"
                  :placeholder="$t('nombre_fantasia')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="taxId">
                <template v-slot:label>{{ $t('tax_id') }}</template>
                <b-form-input id="taxId" v-model="form.taxId" maxlength="30"
                  :placeholder="$t('tax_id')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="web">
                <template v-slot:label>{{ $t('web') }}</template>
                <b-form-input id="web" v-model="form.web" :placeholder="$t('web')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group label-for="direccion">
                <template v-slot:label>
                  {{ $t('direccion') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="direccion" v-model="form.direccion" :placeholder="$t('direccion')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <p class="p-login">{{ $t('pais') }} <span style="color:red">*</span></p>
              <el-select class="custom-input" v-model="form.idPais" @change="onChangePais" filterable clearable
                :placeholder="$t('seleccione')">
                <el-option v-for="item in opcionesPaises" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-col>
            <b-col md="3">
              <p class="p-login">{{ $t('region') }} <span style="color:red">*</span></p>
              <el-select class="custom-input" :disabled="!form.idPais" @change="onChangeRegion" v-model="form.idRegion"
                filterable clearable :placeholder="$t('seleccione')">
                <el-option v-for="item in opcionesRegiones" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-col>
            <b-col md="3">
              <p class="p-login">{{ $t('comuna') }} <span style="color:red">*</span></p>
              <el-select class="custom-input" :disabled="!form.idRegion" v-model="form.idComuna" filterable clearable
                :placeholder="$t('seleccione')">
                <el-option v-for="item in opcionesComunas" :key="item.value" :label="item.text" :value="item.value" />
              </el-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group class="mt-3" label-for="industria">
                <template v-slot:label>{{ $t('industria') }}</template>
                <el-select class="custom-input" v-model="form.idIndustria" filterable clearable
                  :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesIndustriasI18n" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="mt-3" label-for="kam">
                <template v-slot:label>{{ $t('kam') }}</template>
                <el-select class="custom-input" v-model="form.idKam" filterable
                  clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesKAM" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="mt-3" label-for="holding">
                <template v-slot:label>Holding</template>
                <el-select class="custom-input" v-model="form.idHolding" filterable
                  clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesHoldings" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="mt-3" label-for="suscripcion">
                <template v-slot:label>{{ $t('tipo_suscripcion') }}</template>
                <el-select class="custom-input" v-model="form.idSuscripcion" filterable
                  clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesSuscripciones" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- NUEVO BLOQUE: datos de contacto -->
          <b-row class="mt-4">
            <b-col md="4">
              <b-form-group label-for="nombreContacto">
                <template v-slot:label>
                  {{ $t('nombre_contacto') }} <span class="text-danger">*</span>
                </template>
                <b-form-input
                  id="nombreContacto"
                  v-model="form.nombreContacto"
                  required
                  :placeholder="$t('nombre_contacto')"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="mailContacto">
                <template v-slot:label>
                  {{ $t('email_contacto') }} <span class="text-danger">*</span>
                </template>
                <b-form-input
                  id="mailContacto"
                  type="email"
                  v-model="form.mailContacto"
                  required
                  :placeholder="$t('email_contacto')"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="fonoContacto">
                <template v-slot:label>
                  {{ $t('fono_contacto') }} <span class="text-danger">*</span>
                </template>
                <b-form-input
                  id="fonoContacto"
                  type="tel"
                  v-model="form.fonoContacto"
                  required
                  :placeholder="$t('fono_contacto')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <h4 class="mt-4">{{ $t('intereses') }}</h4>
          <b-row>
            <b-col md="4">
              <b-form-group :label="$t('tipos_equipos')">
                <el-select class="custom-input" v-model="form.tipoEquipos" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesEquipos" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('marcas')">
                <el-select v-model="form.marcas" :options="opcionesMarcas" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesMarcas" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('componentes')">
                <el-select v-model="form.componentes" :options="opcionesComponentes"
                  multiple filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesComponentes" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('estado_nuevo_usado')">
                <el-select v-model="form.estados" :options="opcionesEstado" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesEstado" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('procesos')">
                <el-select v-model="form.procesos" :options="opcionesProcesos" multiple
                  filterable clearable :placeholder="$t('seleccione')">
                  <el-option v-for="item in opcionesProcesos" :key="item.value" :label="item.text"
                    :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-button type="submit" variant="primary">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui'
import zonaService from '@/api/zonaService';
import empresaService from '@/api/empresaService';
import userService from '@/api/userService';
import interesService from '@/api/interesService';
import holdingService from '@/api/holdingService';
export default {
  name: 'empresa-crear',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      form: {
        nombre: '',
        nombreFantasia: '',
        taxId: '',
        direccion: '',
        rut: '',
        web: '',
        idPais: null,
        idRegion: null,
        idComuna: null,
        idIndustria: null,
        idKam: null,
        idHolding: null,
        idSuscripcion: null,
         // ← aquí los nuevos campos:
        nombreContacto: '',
        mailContacto: '',
        fonoContacto: '',
        tipoEquipos: [],
        marcas: [],
        componentes: [],
        estado: [],
        procesos: []
      },
      opcionesComunas: [],
      opcionesPaises: [],
      opcionesRegiones: [],
      opcionesIndustrias: [],

      opcionesSuscripciones: [],
      opcionesEquipos: [],
      opcionesMarcas: [],
      opcionesEstado: [],
      opcionesProcesos: [],
      opcionesComponentes: [],
      intereses: [],
      empresaIntereses: [],
      opcionesKAM: [],
      opcionesHoldings: [],
    };
  },
  async beforeMount() {
    await this.initData();
  },
  computed: {
    opcionesIndustriasI18n() {
      return [
        { value: 1, text: this.$t('ind_minera') },
        { value: 2, text: this.$t('ind_salud') },
        { value: 3, text: this.$t('ind_agricola') }
      ].sort((a, b) => String(a.text || '').localeCompare(String(b.text || ''), 'es', { sensitivity: 'base' }));
    }
  },
  methods: {
    async initData() {
      this.opcionesKAM = (await userService.getKamOptions())
        .sort((a, b) => String(a.text || '').localeCompare(String(b.text || ''), 'es', { sensitivity: 'base' }));
      this.opcionesPaises = await zonaService.getPaisesOptions();

      const holdings = await holdingService.getActivos();
      this.opcionesHoldings = Array.isArray(holdings)
        ? holdings.map((item) => ({
            value:
              item && item.value !== undefined && item.value !== null ? item.value
              : item && item.id !== undefined && item.id !== null ? item.id
              : item && item.Id !== undefined && item.Id !== null ? item.Id
              : item && item.idHolding !== undefined && item.idHolding !== null ? item.idHolding
              : item && item.IdHolding !== undefined && item.IdHolding !== null ? item.IdHolding
              : null,
            text:
              item && item.text !== undefined && item.text !== null ? item.text
              : item && item.nombre !== undefined && item.nombre !== null ? item.nombre
              : item && item.name !== undefined && item.name !== null ? item.name
              : item && item.descripcion !== undefined && item.descripcion !== null ? item.descripcion
              : String(item && item.value !== undefined ? item.value : item && item.id !== undefined ? item.id : ''),
          }))
        : [];      
      empresaService.getSuscripcionesOptions().then((data) => (this.opcionesSuscripciones = data));
      if (this.form.idPais)
        this.opcionesRegiones = await zonaService.getRegionesOptions(this.form.idPais);
      if (this.form.idRegion)
        this.opcionesComunas = await zonaService.getComunasOptions(this.form.idRegion);

        interesService.getInteresOptions().then((data) => {
        this.intereses = data;
        this.opcionesEstado = data.find((t) => t.tipo == 'estados').options;
        this.opcionesMarcas = data.find((t) => t.tipo == 'marcas').options;
        this.opcionesEquipos = data.find((t) => t.tipo == 'tipoequipos').options;
        this.opcionesComponentes = data.find((t) => t.tipo == 'componentes').options;
        this.opcionesProcesos = data.find((t) => t.tipo == 'procesos').options;

        this.interesesForm.estados = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'estados')
          .map((i) => i.id);
        this.interesesForm.marcas = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'marcas')
          .map((i) => i.id);
        this.interesesForm.tipoEquipos = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase().replace(' ', '') === 'tipoequipos')
          .map((i) => i.id);
        this.interesesForm.componentes = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'componentes')
          .map((i) => i.id);
        this.interesesForm.procesos = this.empresaIntereses
          .filter((i) => i.tipoInteres.toLowerCase() === 'procesos')
          .map((i) => i.id);
      });

    },
    async onChangePais() {
      this.form.idRegion = null;
      this.opcionesRegiones = await zonaService.getRegionesOptions(this.form.idPais);

    },
    async onChangeRegion() {
      this.form.idComuna = null;
      this.opcionesComunas = await zonaService.getComunasOptions(this.form.idRegion);

    },
    async submitempresa() {

      if (!this.form.idPais || !this.form.idRegion || !this.form.idComuna) {
        this.$toast.error(this.$t('verificar_datos_pais_region'), {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true
        });
        return;
      }

      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('verificar_datos_pregunta'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('crear'),
        cancelButtonText: this.$t('cancelar')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;">
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            const response = await empresaService.create(this.form);
            if (!response) {
              Swal.fire({ icon: "error", title: "Oops...", text: this.$t('error_desconocido') });
              return;
            }
            Swal.fire({
              title: this.$t('creado_correctamente'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000
            });

            this.$router.push(`/clientes/detalle/${response.idEmpresa}`);
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message || this.$t('error_desconocido')
            });
          }
        }
        else if (result.isDenied) {
          Swal.close();
        }
      });
    }
  }
};
</script>
<style scoped>
.p-login {
  margin-bottom: 0;
}

.el-select {
  display: block
}
</style>
